module.exports = __webpack_public_path__ + "static/media/corngreen.6df0c769.svg";